import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { isEqual } from "lodash-es";
import { convertDnaCaretPositionOrRangeToAA } from "@teselagen/sequence-utils";
import { convertRangeTo1Based } from "@teselagen/range-utils";
import selectors from "../../selectors";
export const sizeSchema = (isProtein) => ({
  path: "size",
  type: "number",
  render: (val, _record) => {
    const record = isProtein ? convertDnaCaretPositionOrRangeToAA(_record) : _record;
    const base1Range = convertRangeTo1Based(record);
    const hasJoinedLocations = record.locations && record.locations.length > 1;
    return /* @__PURE__ */ jsxs("span", { children: [
      isProtein ? Math.floor(val / 3) : val,
      " ",
      /* @__PURE__ */ jsx("span", { style: { fontSize: 10 }, children: hasJoinedLocations ? record.locations.map((loc, i) => {
        const base1Range2 = convertRangeTo1Based(loc);
        return /* @__PURE__ */ jsxs("span", { children: [
          "(",
          base1Range2.start,
          "-",
          base1Range2.end,
          ")"
        ] }, i);
      }) : /* @__PURE__ */ jsxs("span", { children: [
        "(",
        base1Range.start,
        "-",
        base1Range.end,
        ")"
      ] }) })
    ] });
  }
});
export const getMemoOrfs = /* @__PURE__ */ (() => {
  let lastDeps;
  let lastResult;
  return (editorState) => {
    const {
      sequenceData,
      minimumOrfSize,
      useAdditionalOrfStartCodons
    } = editorState;
    const { sequence, circular } = sequenceData;
    const deps = {
      sequence,
      circular,
      minimumOrfSize,
      useAdditionalOrfStartCodons
    };
    if (lastResult && isEqual(deps, lastDeps)) {
      return lastResult;
    }
    lastResult = selectors.orfsSelector(editorState);
    lastDeps = deps;
    return lastResult;
  };
})();
